import type { DictFragment } from '../translations';

/** Gérance — resources view: pick a person, see their portfolio-wide workload. */
export const resources: DictFragment = {
  fr: {
    'gerance.view.resources': 'Vue ressources',
    'resources.pickPerson': 'Sélectionner un collaborateur',
    'resources.emptyTitle': 'Aucun collaborateur sélectionné',
    'resources.emptyDesc': 'Choisissez un collaborateur pour voir sa charge sur le portefeuille de projets.',
    'resources.totalHoursPerWeek': 'Heures / semaine (total)',
    'resources.noProjectsTitle': 'Aucun projet',
    'resources.noProjectsDesc': '{name} n’est ni commanditaire ni collaborateur sur aucun projet.',
    'resources.typeSponsor': 'Commanditaire',
    'resources.typeCollaborator': 'Collaborateur',
    'resources.colAllocation': 'Allocation',
    'resources.colHoursPerWeek': 'h / semaine',
    'resources.colStage': 'Étape',
    'resources.colMilestone': 'Jalon',
    'resources.milestoneN': 'Jalon {n}/{total}',
    'resources.colDeadline': 'Échéance',
    'resources.otherCollaborators': 'Voir les autres collaborateurs sur ce projet',
    'resources.noOtherCollaborators': 'Aucun autre collaborateur sur ce projet.',
    'resources.groupActive': 'En cours',
    'resources.groupDeferredBacklog': 'Deferred ou Backlog',
    'resources.groupClosed': 'Closed',
    'resources.modePerson': 'Vue par personne',
    'resources.modeCompare': 'Comparer les collaborateurs',
    'resources.compareEmptyTitle': 'Aucune allocation active',
    'resources.compareEmptyDesc': 'Aucun collaborateur n’a d’heures allouées sur un projet en cours actuellement.',
    'resources.compareCurrentHours': '{hours} h occupé actuellement',
    'resources.compareCurrentlyFree': 'Libre actuellement',
    'resources.compareDragReorder': 'Faire glisser pour réordonner',
  },
  en: {
    'gerance.view.resources': 'Resources view',
    'resources.pickPerson': 'Select a collaborator',
    'resources.emptyTitle': 'No collaborator selected',
    'resources.emptyDesc': 'Pick a collaborator to see their workload across the project portfolio.',
    'resources.totalHoursPerWeek': 'Hours / week (total)',
    'resources.noProjectsTitle': 'No projects',
    'resources.noProjectsDesc': '{name} is neither sponsor nor collaborator on any project.',
    'resources.typeSponsor': 'Sponsor',
    'resources.typeCollaborator': 'Collaborator',
    'resources.colAllocation': 'Allocation',
    'resources.colHoursPerWeek': 'h / week',
    'resources.colStage': 'Stage',
    'resources.colMilestone': 'Milestone',
    'resources.milestoneN': 'Milestone {n}/{total}',
    'resources.colDeadline': 'Deadline',
    'resources.otherCollaborators': 'See other collaborators on this project',
    'resources.noOtherCollaborators': 'No other collaborators on this project.',
    'resources.groupActive': 'Active',
    'resources.groupDeferredBacklog': 'Deferred or Backlog',
    'resources.groupClosed': 'Closed',
    'resources.modePerson': 'Per-person view',
    'resources.modeCompare': 'Compare collaborators',
    'resources.compareEmptyTitle': 'No active allocations',
    'resources.compareEmptyDesc': 'No collaborator currently has hours allocated on an active project.',
    'resources.compareCurrentHours': '{hours} h occupied now',
    'resources.compareCurrentlyFree': 'Currently free',
    'resources.compareDragReorder': 'Drag to reorder',
  },
};
